export default __webpack_public_path__ + "static/media/gold_personal.b67d734a.svg";